module.exports = __webpack_public_path__ + "img/Matty_Qu.247947c0.jpg";